let domEventPool: [HTMLElement | Document, string, (event: Event) => void][] =
  []

export function addEventToPool(
  dom: HTMLElement | Document,
  eventType: string,
  func: (event: Event) => void
) {
  domEventPool.push([dom, eventType, func])
}

export function bindEvents() {
  domEventPool.map(item => {
    const [$dom, eventtype, func] = item
    $dom.addEventListener(eventtype, func)
  })
}

export function unbindEvents() {
  domEventPool.forEach(item => {
    const [$dom, eventtype, func] = item
    $dom.removeEventListener(eventtype, func)
  })

  domEventPool = []
}
